import React, { useState, useEffect, useWindowFocus } from "react";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import Classes from "./Mapofgradesposted/Mapofgrades.js";

// eslint-disable-next-line
import NavBar from "./Navbar";

import { updateDoc, doc } from "firebase/firestore";
import { auth, firebase } from "../Firebase/config";

import "./App.css";
import { getDocs, query, collection, where } from "firebase/firestore";

function App() {
  const { only2studentid, studentid, classid, language, role, id } =
    useParams();

  const [temparray, setTemparray] = useState();

  const [selectedclass, setSelectedclass] = useState();
  const [activeid, setActiveid] = useState();
  const [activename, setActivename] = useState();

  const [selectedclass2, setSelectedclass2] = useState();
  const [activeid2, setActiveid2] = useState();
  const [activename2, setActivename2] = useState();
  const [activeemail2, setactiveemail2] = useState();

  const [currentclass, setCurrentclass] = useState();

  const [currentclasses, setCurrentclasses] = useState();
  const [currentstudents, setCurrentstudents] = useState();

  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [assignmentname, setAssignmentname] = useState();

  const [classlist, setClasslist] = useState([]);
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  // Add a state to trigger reload if loading takes too long
  const [reloadKey, setReloadKey] = useState(0);

  // Minimal useEffect to confirm mounting in all environments
  useEffect(() => {
    console.log("✅ Postgcgrades.js mounted.");
  }, []);

  useEffect(() => {
    console.log("🔄 Starting user data fetch useEffect with id:", id);

    // Don't run if id is undefined or empty
    if (!id) {
      console.warn("⚠️ ID is not available, skipping user data fetch");
      setUserDataLoaded(true); // Mark as loaded even if no ID
      return;
    }

    const fetchUserData = async () => {
      try {
        console.log("📡 Fetching user data for ID:", id);

        const f = query(collection(firebase, "users"), where("id", "==", id));
        console.log("✅ Query created successfully");

        const querySnapshot = await getDocs(f);
        console.log("✅ Query executed, snapshot received");

        if (querySnapshot.empty) {
          console.warn("⚠️ No user found with ID:", id);
          setUserDataLoaded(true); // Mark as loaded even if no user found
          return;
        }

        let dataFound = false;
        querySnapshot.forEach((doc) => {
          console.log("📦 Processing user document:", doc.data());

          const userData = doc.data();

          if (userData.activeclassstudentlist) {
            setClasslist(userData.activeclassstudentlist);
            console.log("✅ Active class ID set:", userData.activeclassid);
          } else {
            console.warn("⚠️ No active class ID found for user");
          }

          if (userData.activeclassid) {
            setActiveid(userData.activeclassid);
            console.log("✅ Active class ID set:", userData.activeclassid);
          } else {
            console.warn("⚠️ No active class ID found for user");
          }

          dataFound = true;
        });

        if (dataFound) {
          console.log("✅ User data fetch completed successfully");
        } else {
          console.warn("⚠️ No data was processed from the query results");
        }

        // Mark user data as loaded
        setUserDataLoaded(true);
        console.log("🎉 User data loading complete - ready for next steps");
      } catch (error) {
        console.error("❌ Error fetching user data:", error);
        console.error("❌ Error stack:", error.stack);

        // Set default values on error
        console.log("🔄 Setting default values due to error");
        setClasslist([]);

        // Mark as loaded even on error so other code can proceed
        setUserDataLoaded(true);
      }
    };

    console.log("🔄 About to call fetchUserData...");
    fetchUserData()
      .then(() => {
        console.log("✅ fetchUserData promise resolved");
      })
      .catch((error) => {
        console.error("❌ fetchUserData promise rejected:", error);
        setUserDataLoaded(true); // Ensure we don't block forever
      });
  }, [id]);

  useEffect(() => {
    if (
      typeof temparray != "undefined" &&
      classlist.length > 0 &&
      typeof assignmentname != "undefined" &&
      typeof activeid != "undefined"
    ) {
      // For each user id in classlist, update their assignment grade if a matching googleclassroomid is found in temparray

      const updateGradesForUsers = async () => {
        try {
          // Query all users whose id is in classlist
          const usersQuery = query(
            collection(firebase, "users"),
            where("id", "in", classlist)
          );
          const usersSnapshot = await getDocs(usersQuery);

          // For each user, find their googleclassroomid and match with temparray
          const batchUpdates = [];
          usersSnapshot.forEach((userDoc) => {
            const userData = userDoc.data();
            const googleClassroomId = userData.googleclassroomid;
            if (!googleClassroomId) return;

            // Find the matching student in temparray

            const nowww = Date.now();
            const matchingStudent = temparray.find(
              (item) => item.id === googleClassroomId
            );
            if (
              matchingStudent &&
              typeof matchingStudent.grade !== "undefined"
            ) {
              // Prepare the update
              batchUpdates.push(
                updateDoc(doc(firebase, "users", userDoc.id), {
                  [`${activeid}.assignmentname`]: assignmentname,
                  [`${activeid}.assignmentgrade`]: matchingStudent.grade,
                  [`${activeid}.assignmentsent`]: nowww,
                })
              );
            }
          });

          // Execute all updates in parallel
          await Promise.all(batchUpdates);
          console.log("All user grades updated successfully.");
        } catch (error) {
          console.error("Error updating user grades:", error);
        }
      };

      updateGradesForUsers();
    }
  }, [classlist, temparray, assignmentname, activeid]);

  useEffect(() => {
    const storedStudents = localStorage.getItem("allstudents");
    const storedClasses = localStorage.getItem("myclasses");

    const storedClassname = localStorage.getItem("activename");
    const storedClassid = localStorage.getItem("activeid");

    if (storedClassname) {
      try {
        setActivename(storedClassname);
        console.log(
          "Active class name set from localStorage:",
          storedClassname
        );
      } catch (error) {
        console.error("Failed to parse classname from localStorage:", error);
      }
    } else {
      console.warn("No activename data found in localStorage.");
    }

    if (storedClassid) {
      try {
        setActiveid(storedClassid);
        console.log("Active class ID set from localStorage:", storedClassid);
      } catch (error) {
        console.error("Failed to parse classid from localStorage:", error);
      }
    } else {
      console.warn("No activeid data found in localStorage.");
    }

    if (storedStudents) {
      try {
        setCurrentstudents(JSON.parse(storedStudents));
      } catch (error) {
        console.error("Failed to parse allstudents from localStorage:", error);
      }
    } else {
      console.warn("No allstudents data found in localStorage.");
    }

    if (storedClasses) {
      try {
        setCurrentclasses(JSON.parse(storedClasses));
      } catch (error) {
        console.error("Failed to parse myclasses from localStorage:", error);
      }
    } else {
      console.warn("No myclasses data found in localStorage.");
    }
  }, []);

  useEffect(() => {
    console.log("See if role shows up and id", role, id);
  }, []);

  useEffect(() => {
    console.log("See if role shows up and id", role, id);
  }, []);

  useEffect(() => {
    // Parse the query parameters from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const studentsDataEncoded = urlParams.get("studentsWithGrades"); // Correct parameter name

    const accessToken = urlParams.get("access_token");
    const refreshToken = urlParams.get("refresh_token");
    const expiryDate = urlParams.get("expiry_date");

    const assignmentname = urlParams.get("assignmentName");

    console.log("🔍 URL Params:", {
      studentsDataEncoded,
      accessToken,
      refreshToken,
      expiryDate,
      assignmentname,
    });

    if (assignmentname) {
      setAssignmentname(assignmentname);
      localStorage.setItem("assignment_name", assignmentname);
      console.log(
        "Assignment name set and saved to localStorage:",
        assignmentname
      );
    } else {
      console.warn("No assignment name found in the URL.");
    }

    if (accessToken) {
      setAccesstoken(accessToken);
      localStorage.setItem("access_token", accessToken);
      console.log("Access token set and saved to localStorage:", accessToken);
    } else {
      console.warn("No access token found in the URL.");
    }

    if (refreshToken) {
      setRefreshtoken(refreshToken);
      localStorage.setItem("refresh_token", refreshToken);
      console.log("Refresh token set and saved to localStorage:", refreshToken);
    } else {
      console.warn("No refresh token found in the URL.");
    }

    if (expiryDate) {
      setExpiryDate(expiryDate);
      localStorage.setItem("expiry_date", expiryDate);
      console.log("Expiry date set and saved to localStorage:", expiryDate);
    } else {
      console.warn("No expiry date found in the URL.");
    }

    if (studentsDataEncoded) {
      try {
        // Decode and parse the students data
        const studentsData = JSON.parse(
          decodeURIComponent(studentsDataEncoded)
        );
        console.log("Student data received:", studentsData);
        setTemparray(studentsData);
      } catch (error) {
        console.error("Failed to decode or parse students data:", error);
      }
    } else {
      console.warn("No students data found in the URL.");
    }
  }, []);

  useEffect(() => {
    const updateGrades = async () => {
      if (
        typeof temparray != "undefined" &&
        typeof assignmentname != "undefined"
      ) {
        let gcgradesofselectedassignment = {
          assignmentname: assignmentname,
          studentscores: temparray,
        };

        try {
          await updateDoc(doc(firebase, "users", id), {
            gcgradesofselectedassignment: gcgradesofselectedassignment,
          });
          console.log("You can now send messages with scores from this assignment!");
        } catch (error) {
          console.log(error);
          console.log(error);
        }
      }
    };

    updateGrades();
  }, [temparray, assignmentname]);

  //gooogle claassroom classes
  useEffect(() => {
    if (typeof selectedclass2 != "undefined") {
      setActiveid2(selectedclass2.id);
      setActivename2(selectedclass2.name);
    }
  }, [selectedclass2]);

  //claassesss from the database
  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActivename(selectedclass.classname);
    }
  }, [selectedclass]);

  // If loading takes more than 2 seconds, reload the page
  useEffect(() => {
    if (!userDataLoaded) {
      const timeout = setTimeout(() => {
        if (!userDataLoaded) {
          console.warn("⏳ Still loading after 2 seconds, reloading page...");
          window.location.reload();
        }
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [userDataLoaded]);

  // Show loading indicator until userDataLoaded is true
  if (!userDataLoaded) {
    return (
      <div className="App22">
           <NavBar
        role={role}
        temparray={currentclasses}
        activename2={activename2}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activename={activename}
        //because it is an endpoint than you need to returrn from.
        noclasschangeandmainmenuonly={true}
      />
         <div className="App">
        <header className="App-header"> <h2>Loading user data...</h2></header>
        </div>
      </div>
    );
  }

  return (
    <div className="App22">
      <NavBar
        role={role}
        temparray={currentclasses}
        activename2={activename2}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activename={activename}
        //because it is an endpoint than you need to returrn from.
        noclasschangeandmainmenuonly={true}
      />
      <div className="App">
        <header className="App-header">
          {/* 
            <Link to="/" style={{ textDecoration: 'none' }}>
          Return Home
          </Link> */}

          <Classes
            currentclass={currentclass}
            activename={activename2}
            databaseactivename={activename}
            setSelectedclass={setSelectedclass2}
            activeid2={activeid2}
            selectedclass={selectedclass2}
            temparray={temparray}
            id={id}
            activeid={activeid}
            assignmentname={assignmentname}
          />
        </header>
      </div>
    </div>
  );
}

export default App;
